import React from 'react'

const Inspirations = () => (
  <div className='flex-c h-margin gray'>
    <h3 className='h-margin'>Inspirations</h3>
    <h3 className='h-margin'>Coming Soon</h3>
  </div>
)

export default Inspirations